import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";

export default function Curriculum() {
    const [pillars, setPillars] = useState([]);

    useEffect(() => {
        api.get("/curriculum").then((r) => setPillars(r.data));
    }, []);

    return (
        <main className="container-page py-12 fade-up">
            <p className="label-eyebrow mb-2">Curriculum</p>
            <h1 className="text-4xl font-semibold text-[#1C2321] mb-3" style={{ fontFamily: "Outfit" }} data-testid="curriculum-title">
                The Science of Reading, in five steps
            </h1>
            <p className="text-lg text-[#515B57] max-w-2xl mb-10">
                Each pillar builds on the one before it. Start at the top and work down &mdash; or jump in wherever you want.
            </p>

            <div className="space-y-5">
                {pillars.map((p) => (
                    <Link
                        key={p.id}
                        to={`/app/curriculum/${p.id}`}
                        data-testid={`curriculum-pillar-${p.id}`}
                        className="card-rw p-7 md:p-9 flex items-start gap-6 hover:-translate-y-0.5"
                    >
                        <div className="w-14 h-14 rounded-xl bg-[#E0EDE6] flex items-center justify-center text-2xl font-semibold text-[#2D5D4E]" style={{ fontFamily: "Outfit" }}>
                            {p.order}
                        </div>
                        <div className="flex-1">
                            <h2 className="text-2xl font-medium mb-1" style={{ fontFamily: "Outfit" }}>{p.title}</h2>
                            <p className="text-[#515B57] text-lg mb-3">{p.subtitle}</p>
                            <p className="text-sm text-[#819888]">{p.lesson_count} lessons</p>
                        </div>
                        <ArrowRight className="w-6 h-6 text-[#2D5D4E] mt-2" strokeWidth={1.6} />
                    </Link>
                ))}
            </div>
        </main>
    );
}
